import React from 'react';
import { CreditCard } from 'lucide-react';
import { useCredits } from '../../hooks/useCredits';

export default function CreditsIndicator() {
  const { credits, loading } = useCredits();
  
  if (loading) {
    return <div className="animate-pulse bg-gray-200 h-16 rounded-lg"></div>;
  }

  return (
    <div className="bg-white rounded-lg shadow p-4 flex items-center justify-between">
      <div className="flex items-center">
        <CreditCard className="w-6 h-6 text-blue-600 mr-3" />
        <div>
          <h3 className="text-sm font-medium text-gray-600">Available Credits</h3>
          <p className="text-2xl font-bold text-gray-900">{credits}</p>
        </div>
      </div>
      <div className="text-sm text-gray-500">
        
      </div>
    </div>
  );
}